import React, { Component } from "react";
import "../../../assets/css/selectOption.css";
class SelectOption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.selectRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (
      this.selectRef.current &&
      !this.selectRef.current.contains(event.target)
    ) {
      this.handleClose();
    }
  };
  handleOpen = (e) => {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };
  handleClose = () => {
    this.setState({ isOpen: false });
  };
  render() {
    return (
      <div
        className="select-option-wrapper text-white position-relative"
        ref={this.selectRef}
        onClick={this.handleOpen}
      >
        <button className=" text-white" type="button">
          {this.props?.choosedCommission?.name}{" "}
          <i className="fas fa-caret-down"></i>
        </button>
        {this.state.isOpen && (
          <div
            className="select-option-items position-absolute"
            style={{
              width: "max-content",
            }}
          >
            {this.props?.listCommission?.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    this.props.handleCommission(item);
                  }}
                  className="item-select"
                  key={index}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
export default SelectOption;
